/* Raquex PDP test (Option B): dispatch countdown, price in the CTA,
   Trustpilot rating beside the review stars.
   Fails silent. If anything here throws, the page keeps the theme's
   default button label and a static dispatch line. */
(function () {
  'use strict';

  // Edit this line to change the Trustpilot score shown beside the stars.
  var TRUSTPILOT = '4.8';

  /* ---------- dispatch countdown ---------- */
  // Parts of "now" as they are in London, whatever the viewer's timezone.
  function londonNow() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'short',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      day: p.weekday,
      h: parseInt(p.hour, 10) % 24,
      m: parseInt(p.minute, 10),
      s: parseInt(p.second, 10)
    };
  }

  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var NEXT = { Fri: 'Monday', Sat: 'Monday', Sun: 'Monday',
               Mon: 'tomorrow', Tue: 'tomorrow', Wed: 'tomorrow', Thu: 'tomorrow' };

  function renderDispatch(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '16', 10);
    var t = londonNow();
    var isWeekday = DAYS.indexOf(t.day) > -1 && DAYS.indexOf(t.day) < 5;
    var slot = el.querySelector('[data-rqx-dispatch-text]');
    if (!slot) return;

    if (isWeekday && t.h < cutoff) {
      var left = (cutoff * 3600) - (t.h * 3600 + t.m * 60 + t.s);
      var hh = Math.floor(left / 3600);
      var mm = Math.floor((left % 3600) / 60);
      var clock = hh > 0 ? hh + 'h ' + mm + 'm' : mm + 'm';
      slot.innerHTML = 'Order in <span class="rqx-dispatch__time"></span> for same-day dispatch';
      slot.querySelector('.rqx-dispatch__time').textContent = clock;
    } else {
      slot.textContent = 'Order now for dispatch ' +
        (NEXT[t.day] === 'tomorrow' ? 'tomorrow' : 'on ' + NEXT[t.day]);
    }
  }

  function startDispatch() {
    var els = document.querySelectorAll('[data-rqx-dispatch]');
    if (!els.length) return;
    Array.prototype.forEach.call(els, renderDispatch);
    setInterval(function () {
      Array.prototype.forEach.call(els, renderDispatch);
    }, 30000);
  }

  /* ---------- Trustpilot beside the Judge.me stars ----------
     The star badge is an app block we cannot edit, so the rating is
     appended to it. Scoped to the buy box form: there are ~27 of these
     badges on a product page and the rest belong to related product
     cards. Judge.me renders late, hence the retry on mutation. */
  function ensureTrustpilot() {
    var badge = document.querySelector('.shopify-product-form .jdgm-prev-badge');
    if (!badge || badge.querySelector('[data-rqx-tp]')) return;
    var s = document.createElement('span');
    s.className = 'rqx-tp';
    s.setAttribute('data-rqx-tp', '');
    s.innerHTML = ' · Rated <b></b> on Trustpilot';
    s.querySelector('b').textContent = TRUSTPILOT;
    badge.appendChild(s);
  }

  /* ---------- price in the add to cart button ---------- */
  function priceText() {
    var el = document.querySelector('.product-price .price-item--regular, .product-price .price-item--sale, .product-price');
    if (!el) return null;
    var m = (el.textContent || '').match(/[£$€]\s?[\d,]+(?:\.\d{2})?/);
    return m ? m[0].replace(/\s/g, '') : null;
  }

  function syncButton() {
    // This theme's buttons carry no name="add". The shared hook is
    // .add-to-cart, which also catches the sticky bar's button.
    var btns = document.querySelectorAll('.add-to-cart');
    if (!btns.length) return;
    var p = priceText();
    Array.prototype.forEach.call(btns, function (btn) {
      var span = btn.querySelector('[data-rqx-cta-label]');
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('data-rqx-cta-label', '');
        btn.appendChild(span);
      }
      // Suppressed while the variant is unavailable: the theme swaps the
      // label to "Sold out" and a price beside it would read as a bug.
      var label = (btn.textContent || '').replace(span.textContent, '');
      var sold = /sold\s*out|unavailable/i.test(label);
      span.textContent = (p && !sold) ? ' · ' + p : '';
    });
  }

  function tick() {
    try { syncButton(); } catch (e) {}
    try { ensureTrustpilot(); } catch (e) {}
  }

  function start() {
    try { startDispatch(); } catch (e) {}
    tick();
    try {
      // Variant pickers re-render the price node and Judge.me injects late,
      // so watch the document rather than guessing at this theme's events.
      if (window.MutationObserver) {
        var pending = null;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(tick, 120);
        }).observe(document.body, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
